export const PaymentHistoryMode = {
	ALL: 'allPayments',
	INSTALMENTS: 'instalmentPayments'
};

export const mapStatusToLabel = (status) => {
	/*
		Created = 0,
		Pending = 1,
		NotApproved = 6,
		Paid = 2,
		Cancelled = 3,
		Expired = 4,
		Credit = 5
	*/
	switch (status) {
		case 2:
			return 'success';
		case 1:	//return 'primary';
		case 6:
			return 'warning';
		case 3:
		case 4:
			return 'danger';
		default:
			return 'inverse';
	}
};